export interface MedicalSpecialty {
  id: string;
  category: number;
  specialty_name: [string, string]; // [0: ES, 1: EN]
  specialist_name: [string, string]; // [0: ES, 1: EN]
}

export const MEDICAL_SPECIALTIES: MedicalSpecialty[] = [
  {
    id: "6878106feafd3a6db44d25e4",
    category: 1,
    specialty_name: ["Anestesiología", "anesthesiology"],
    specialist_name: ["Anestesiólogo", "anesthesiologist"],
  },
  {
    id: "6878106feafd3a6db44d25e5",
    category: 2,
    specialty_name: ["Angiología, Cirugía Vascular y Endovascular", "angiology, vascular and endovascular surgery"],
    specialist_name: ["Angiólogo", "angiologist"],
  },
  {
    id: "6878106feafd3a6db44d25e6",
    category: 3,
    specialty_name: ["Audiología, Otoneurología y Foniatría", "audiology, otoneurology and phoniatrics"],
    specialist_name: ["Audiólogo", "audiologist"],
  },
  {
    id: "6878106feafd3a6db44d25e7",
    category: 4,
    specialty_name: ["Cardiología Clínica", "clinical cardiology"],
    specialist_name: ["Cardiólogo", "cardiologist"],
  },
  {
    id: "6878106feafd3a6db44d25e8",
    category: 5,
    specialty_name: ["Cirugía General", "general surgery"],
    specialist_name: ["Cirujano General", "general surgeon"],
  },
  {
    id: "6878106feafd3a6db44d25e9",
    category: 6,
    specialty_name: ["Cirugía Neurológica", "neurosurgery"],
    specialist_name: ["Neurocirujano", "neurosurgeon"],
  },
  {
    id: "6878106feafd3a6db44d25ea",
    category: 7,
    specialty_name: ["Cirugía Oral y Maxilofacial", "oral and maxillofacial surgery"],
    specialist_name: ["Cirujano Maxilofacial", "maxillofacial surgeon"],
  },
  {
    id: "6878106feafd3a6db44d25eb",
    category: 8,
    specialty_name: ["Cirugía Pediátrica", "pediatric surgery"],
    specialist_name: ["Cirujano Pediatra", "pediatric surgeon"],
  },
  {
    id: "6878106feafd3a6db44d25ec",
    category: 9,
    specialty_name: ["Cirugía Plástica, Estética y Reconstructiva", "plastic, aesthetic and reconstructive surgery"],
    specialist_name: ["Cirujano Plástico", "plastic surgeon"],
  },
  {
    id: "6878106feafd3a6db44d25ed",
    category: 10,
    specialty_name: ["Cirugía Torácica", "thoracic surgery"],
    specialist_name: ["Cirujano Torácico", "thoracic surgeon"],
  },
  {
    id: "6878106feafd3a6db44d25ee",
    category: 11,
    specialty_name: ["Coloproctología", "coloproctology"],
    specialist_name: ["Coloproctólogo", "coloproctologist"],
  },
  {
    id: "6878106feafd3a6db44d25ef",
    category: 12,
    specialty_name: ["Comunicación Humana", "human communication"],
    specialist_name: ["Foniatra", "phoniatrician"],
  },
  {
    id: "6878106feafd3a6db44d25f0",
    category: 13,
    specialty_name: ["Dermatología", "dermatology"],
    specialist_name: ["Dermatólogo", "dermatologist"],
  },
  {
    id: "6878106feafd3a6db44d25f1",
    category: 14,
    specialty_name: ["Endocrinología", "endocrinology"],
    specialist_name: ["Endocrinólogo", "endocrinologist"],
  },
  {
    id: "6878106feafd3a6db44d25f2",
    category: 15,
    specialty_name: ["Gastroenterología", "gastroenterology"],
    specialist_name: ["Gastroenterólogo", "gastroenterologist"],
  },
  {
    id: "6878106feafd3a6db44d25f3",
    category: 16,
    specialty_name: ["Genética Médica", "medical genetics"],
    specialist_name: ["Genetista", "geneticist"],
  },
  {
    id: "6878106feafd3a6db44d25f4",
    category: 17,
    specialty_name: ["Geriatría", "geriatrics"],
    specialist_name: ["Geriatra", "geriatrician"],
  },
  {
    id: "6878106feafd3a6db44d25f5",
    category: 18,
    specialty_name: ["Ginecología y Obstetricia", "gynecology and obstetrics"],
    specialist_name: ["Ginecólogo", "gynecologist"],
  },
  {
    id: "6878106feafd3a6db44d25f6",
    category: 19,
    specialty_name: ["Hematología", "hematology"],
    specialist_name: ["Hematólogo", "hematologist"],
  },
  {
    id: "6878106feafd3a6db44d25f7",
    category: 20,
    specialty_name: ["Infectología", "infectology"],
    specialist_name: ["Infectólogo", "infectologist"],
  },
  {
    id: "6878106feafd3a6db44d25f8",
    category: 21,
    specialty_name: ["Medicina Crítica", "critical care medicine"],
    specialist_name: ["Intensivista", "intensivist"],
  },
  {
    id: "6878106feafd3a6db44d25f9",
    category: 22,
    specialty_name: ["Medicina del Deporte", "sports medicine"],
    specialist_name: ["Médico del Deporte", "sports physician"],
  },
  {
    id: "6878106feafd3a6db44d25fa",
    category: 23,
    specialty_name: ["Medicina del Trabajo", "occupational medicine"],
    specialist_name: ["Médico del Trabajo", "occupational physician"],
  },
  {
    id: "6878106feafd3a6db44d25fb",
    category: 24,
    specialty_name: ["Medicina Familiar", "family medicine"],
    specialist_name: ["Médico Familiar", "family physician"],
  },
  {
    id: "6878106feafd3a6db44d25fc",
    category: 25,
    specialty_name: ["Medicina Interna", "internal medicine"],
    specialist_name: ["Internista", "internist"],
  },
  {
    id: "6878106feafd3a6db44d25fd",
    category: 26,
    specialty_name: ["Medicina Legal y Forense", "legal and forensic medicine"],
    specialist_name: ["Forense", "forensic physician"],
  },
  {
    id: "6878106feafd3a6db44d25fe",
    category: 27,
    specialty_name: ["Medicina Nuclear", "nuclear medicine"],
    specialist_name: ["Médico Nuclear", "nuclear physician"],
  },
  {
    id: "6878106feafd3a6db44d25ff",
    category: 28,
    specialty_name: ["Medicina Preventiva", "preventive medicine"],
    specialist_name: ["Epidemiólogo", "epidemiologist"],
  },
  {
    id: "6878106feafd3a6db44d2600",
    category: 29,
    specialty_name: ["Medicina de Rehabilitación", "rehabilitation medicine"],
    specialist_name: ["Fisiatra", "physiatrist"],
  },
  {
    id: "6878106feafd3a6db44d2601",
    category: 30,
    specialty_name: ["Medicina de Urgencias", "emergency medicine"],
    specialist_name: ["Urgenciólogo", "emergency physician"],
  },
  {
    id: "6878106feafd3a6db44d2602",
    category: 31,
    specialty_name: ["Nefrología", "nephrology"],
    specialist_name: ["Nefrólogo", "nephrologist"],
  },
  {
    id: "6878106feafd3a6db44d2603",
    category: 32,
    specialty_name: ["Neumología", "pulmonology"],
    specialist_name: ["Neumólogo", "pulmonologist"],
  },
  {
    id: "6878106feafd3a6db44d2604",
    category: 33,
    specialty_name: ["Neurocirugía", "neurosurgery"],
    specialist_name: ["Neurocirujano", "neurosurgeon"],
  },
  {
    id: "6878106feafd3a6db44d2605",
    category: 34,
    specialty_name: ["Neurología", "neurology"],
    specialist_name: ["Neurólogo", "neurologist"],
  },
  {
    id: "6878106feafd3a6db44d2606",
    category: 35,
    specialty_name: ["Oftalmología", "ophthalmology"],
    specialist_name: ["Oftalmólogo", "ophthalmologist"],
  },
  {
    id: "6878106feafd3a6db44d2607",
    category: 36,
    specialty_name: ["Oncología Médica", "medical oncology"],
    specialist_name: ["Oncólogo", "oncologist"],
  },
  {
    id: "6878106feafd3a6db44d2608",
    category: 37,
    specialty_name: ["Ortopedia y Traumatología", "orthopedics and traumatology"],
    specialist_name: ["Ortopedista", "orthopedic surgeon"],
  },
  {
    id: "6878106feafd3a6db44d2609",
    category: 38,
    specialty_name: ["Otorrinolaringología", "otolaryngology"],
    specialist_name: ["Otorrinolaringólogo", "otolaryngologist"],
  },
  {
    id: "6878106feafd3a6db44d260a",
    category: 39,
    specialty_name: ["Patología Clínica", "clinical pathology"],
    specialist_name: ["Patólogo Clínico", "clinical pathologist"],
  },
  {
    id: "6878106feafd3a6db44d260b",
    category: 40,
    specialty_name: ["Pediatría", "pediatrics"],
    specialist_name: ["Pediatra", "pediatrician"],
  },
  {
    id: "6878106feafd3a6db44d260c",
    category: 41,
    specialty_name: ["Psiquiatría", "psychiatry"],
    specialist_name: ["Psiquiatra", "psychiatrist"],
  },
  {
    id: "6878106feafd3a6db44d260d",
    category: 42,
    specialty_name: ["Radiología e Imagen", "radiology and imaging"],
    specialist_name: ["Radiólogo", "radiologist"],
  },
  {
    id: "6878106feafd3a6db44d260e",
    category: 43,
    specialty_name: ["Radio Oncología", "radiation oncology"],
    specialist_name: ["Radiooncólogo", "radiation oncologist"],
  },
  {
    id: "6878106feafd3a6db44d260f",
    category: 44,
    specialty_name: ["Reumatología", "rheumatology"],
    specialist_name: ["Reumatólogo", "rheumatologist"],
  },
  {
    id: "6878106feafd3a6db44d2610",
    category: 45,
    specialty_name: ["Salud Pública", "public health"],
    specialist_name: ["Salubrista", "public health specialist"],
  },
  {
    id: "6878106feafd3a6db44d2611",
    category: 46,
    specialty_name: ["Urología", "urology"],
    specialist_name: ["Urólogo", "urologist"],
  },
  {
    id: "68e7fee3ff683642cd2e5c5f",
    category: 47,
    specialty_name: ["Anatomía Patológica", "pathological anatomy"],
    specialist_name: ["Anatomopatólogo", "pathologist"],
  },
];